import {UtmCodeParams} from '../../types/UtmCodeParams';

const KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];

export const buildUtmCodesObject = (queryParamString?: string): UtmCodeParams | undefined => {
  const params = new URLSearchParams(queryParamString);
  const utmCodes: UtmCodeParams = {};

  params.forEach((value, name) => {
    if (KEYS.some((key) => key === name)) {
      utmCodes[name] = value;
    }
  });

  return Object.keys(utmCodes).length ? utmCodes : undefined;
};
